import { createThemeCompiler } from '../../../utils';

export const popupThemeCompiler = createThemeCompiler(({ palette, borderRadius }) => ({
    popup: {
        colors: {
            popupCalloutBackgroundColor: palette.white,
            popupCloseIconColor: palette.neutralPrimary,
            popupTitleColor: palette.themeLight
        },
        composites: {
            popupCalloutBorderRadius: borderRadius.curvedLarge
        }
    }
}));
